import { cva } from "class-variance-authority"

/**
 * Distance Floating UI keeps between popover content and the collision
 * boundary (viewport by default). Shared with callers that pre-compute the
 * space a popover gets on a side before it opens.
 */
export const POPOVER_COLLISION_PADDING = 6

export const popoverContentVariants = cva("ui-popover-content", {
  variants: {
    spacing: {
      true: "p-4",
      false: "",
    },
    size: {
      fit: "",
      md: "min-w-64 w-64 max-w-64",
      lg: "min-w-60 w-80 max-w-80",
      "match-trigger": "w-[var(--radix-popover-trigger-width)]",
    },
  },
  defaultVariants: {
    spacing: true,
    size: "md",
  },
})
